import type { ReactNode } from 'react';
import type { UserSummary } from '../../shared/types';

export function AppShell({
  user,onLogout,children,onList,onAbilities,onKits,onPresets,onLogs,active,
}: {
  user: UserSummary; onLogout: () => void; children: ReactNode;
  onList: () => void; onAbilities: () => void; onKits: () => void; onPresets: () => void; onLogs: () => void;
  active: 'items'|'abilities'|'kits'|'presets'|'logs';
}) {
  return <div className="myy-app-shell">
    <header className="topbar">
      <button className="brand-button" onClick={onList}><img src="/assets/logo-mark.svg"/><span><strong>MYY Content Studio</strong><small>Project MYY</small></span></button>
      <div className="topbar-title">Zentrale Inhaltsverwaltung</div>
      <div className="profile"><div className="avatar">{user.displayName.slice(0,1).toUpperCase()}</div><div><strong>{user.displayName}</strong><small>{user.role==='admin'?'Administrator':'Editor'}</small></div><button className="button ghost small" onClick={onLogout}>Abmelden</button></div>
    </header>
    <aside className="sidebar"><nav>
      <button className={active==='items'?'active':''} onClick={onList}><img src="/assets/items.svg"/>Items</button>
      <button className={active==='abilities'?'active':''} onClick={onAbilities}><img src="/assets/quill.svg"/>Fähigkeiten</button>
      <button className={active==='kits'?'active':''} onClick={onKits}><img src="/assets/items.svg"/>Combat Kits</button>
      <button className={active==='presets'?'active':''} onClick={onPresets}><img src="/assets/quill.svg"/>Reichweiten & Radien</button>
      <button className={active==='logs'?'active':''} onClick={onLogs}><img src="/assets/scroll.svg"/>Debug-Log</button>
    </nav><div className="sidebar-note"><img src="/assets/quill.svg"/><strong>Version 5.0.0</strong><span>Fähigkeiten und Items enthalten direktes Gameplay. Animationen und VFX werden ausschließlich in Unreal erstellt.</span></div></aside>
    <main className="main-content">{children}</main>
  </div>;
}
